import { IObject } from "@quest/base-core";

export const eventDispatchers: IObject = {
  SHOW_POSTLOADING_VIEW: "SHOW_POSTLOADING_VIEW",
  UPDATE_JACKPOT_METER_VALUE: "UPDATE_JACKPOT_METER_VALUE",
  UPDATE_JACKPOT_METER_VALUE_FG: "UPDATE_JACKPOT_METER_VALUE_FG",
  UDPATE_NEW_REELSET: "UDPATE_NEW_REELSET",

  // CaseCade Game Events
  CHECK_AND_SHOW_NEXT_CASCADE_PRESENTATION: "CHECK_AND_SHOW_NEXT_CASCADE_PRESENTATION",
  RESET_CASCADE_COUNTER: "RESET_CASCADE_COUNTER",
  STAGE_CLICK_ON_CASCADE: "STAGE_CLICK_ON_CASCADE",
  PARSE_NEXT_CASCADE_DATA: "PARSE_NEXT_CASCADE_DATA",
  SHOW_SYM_WIN: "SHOW_SYM_WIN",
  ON_CASCADE_REELS: "ON_CASCADE_REELS",
  CASCADE_SPIN_COMPLETE: "CASCADE_SPIN_COMPLETE",
  BURST_SYMBOLS: "BURST_SYMBOLS",
  BURST_SYMBOLS_DESTROY: "BURST_SYMBOLS_DESTROY",

  //progress bar
  UPDATE_PROGRESS_BAR_IN_BASEGAME: "UPDATE_PROGRESS_BAR_IN_BASEGAME",
  RESET_PROGRESS_BAR_IN_BASEGAME: "RESET_PROGRESS_BAR_IN_BASEGAME",
  ALLIGN_PROGRESS_BALLS_BASEGAME: "ALLIGN_PROGRESS_BALLS_BASEGAME",
  ALLIGN_PROGRESS_BALLS_FREEGAME: "ALLIGN_PROGRESS_BALLS_FREEGAME",
  // Cascade FG Events
  SHOW_FG_SYM_WIN: "SHOW_FG_SYM_WIN",
  FG_CASCADE_SPIN_COMPLETE: "FG_CASCADE_SPIN_COMPLETE",
  FG_BURST_SYMBOLS: "FG_BURST_SYMBOLS",
  FG_BURST_SYMBOLS_DESTROY: "FG_BURST_SYMBOLS_DESTROY",

  // Free Game Reel Set
  UDPATE_NEW_FG_REELSET: "UDPATE_NEW_FG_REELSET",

  INITIALIZE_CLUSTER_WIN_FRAME: "INITIALIZE_CLUSTER_WIN_FRAME",
  SHOW_CLUSTER_WIN_FRAME: "SHOW_CLUSTER_WIN_FRAME",
  HIDE_CLUSTER_WIN_FRAME: "HIDE_CLUSTER_WIN_FRAME",

  // Fg cluster win frame
  INITIALIZE_FG_CLUSTER_WIN_FRAME: "INITIALIZE_FG_CLUSTER_WIN_FRAME",
  SHOW_FG_CLUSTER_WIN_FRAME: "SHOW_FG_CLUSTER_WIN_FRAME",
  HIDE_FG_CLUSTER_WIN_FRAME: "HIDE_FG_CLUSTER_WIN_FRAME",

  //proresss bar fg
  UPDATE_PROGRESS_BAR_IN_FREEGAME: "UPDATE_PROGRESS_BAR_IN_FREEGAME",
  RESET_PROGRESS_BAR_IN_FREEGAME: "RESET_PROGRESS_BAR_IN_FREEGAME",

  REMOVE_ANTICIPATION_CONT:"REMOVE_ANTICIPATION_CONT",
  PLAY_ANTICIPATION_ON_TV_REELS: "PLAY_ANTICIPATION_ON_TV_REELS",
  // win mask for stack symbol
  CREATE_WIN_MASK: "CREATE_WIN_MASK",
  CREATE_WIN_MASK_FG: "CREATE_WIN_MASK_FG",
  ADD_RESPIN_INTRO_OUTRO_ON_TOP: "ADD_RESPIN_INTRO_OUTRO_ON_TOP",
  //Qline Player Msg

  SHOW_QLINE_PLAYER_MSG: "SHOW_QLINE_PLAYER_MSG",
  HIDE_QLINE_PLAYER_MSG: "HIDE_QLINE_PLAYER_MSG",
  FG_SHOW_QLINE_PLAYER_MSG: "FG_SHOW_QLINE_PLAYER_MSG",
  FG_HIDE_QLINE_PLAYER_MSG: "FG_HIDE_QLINE_PLAYER_MSG",

  //Reveal Symbol Events
  SHOW_REVEAL_SYMBOL: "SHOW_REVEAL_SYMBOL",
  AFTER_REVEAL_COMPLETE: "AFTER_REVEAL_COMPLETE",

  FG_SHOW_REVEAL_SYMBOL: "FG_SHOW_REVEAL_SYMBOL",

  //Bait Symbol Events
  CONVERT_CHEST_INTO_BAIT: "CONVERT_CHEST_INTO_BAIT",
  UPDATE_STATIC_GRID: "UPDATE_STATIC_GRID",
  SHOW_BAIT_SYM_ANIM: "SHOW_BAIT_SYM_ANIM",
  //Fishing time Feature
  INITIALIZE_FISHING_TIME_FEATURE: "INITIALIZE_FISHING_TIME_FEATURE",
  SHOW_RESPIN_INTRO: "SHOW_RESPIN_INTRO",
  //hold and respin
  START_RESPIN_INTRO: "START_RESPIN_INTRO",
  PARSE_NEXT_HOLD_AND_RESPIN_DATA: "PARSE_NEXT_HOLD_AND_RESPIN_DATA",
  INITIALIZE_RESPIN_FEATURE: "INITIALIZE_RESPIN_FEATURE",
  SHOW_NEXT_FEATURE_PRESENTATION: "SHOW_NEXT_FEATURE_PRESENTATION",
  START_RESPIN_OUTRO: "START_RESPIN_OUTRO",
  PLAY_MOVING_BAIT_IDLE: "PLAY_MOVING_BAIT_IDLE",
  START_TV_REEL_SPINNING: "START_TV_REEL_SPINNING",
  STOP_TV_REEL: "STOP_TV_REEL",
  STOP_INITIAL_SYM_APPEREARED_REEL: "STOP_INITIAL_SYM_APPEREARED_REEL",
  SHOW_SYMBOL_ON_REEL: "SHOW_SYMBOL_ON_REEL",
  SEND_NEXT_SPIN_FLOW: "SEND_NEXT_SPIN_FLOW",
  UPDATE_REEL_SYMBOL: "UPDATE_REEL_SYMBOL",
  MOVE_AUTO_PILOT_BAIT: "MOVE_AUTO_PILOT_BAIT",


  HIDE_REEL_BEHIND_FISH: "HIDE_REEL_BEHIND_FISH",
  SHOW_REEL_BEHIND_FISH: "SHOW_REEL_BEHIND_FISH",
  COLLECT_BIG_FISH: "COLLECT_BIG_FISH",
  SHOW_WIN_COLLECTION_TRAIL: "SHOW_WIN_COLLECTION_TRAIL",
  PLAY_HOLD_AND_RESPIN_BLAST_ON_WIN_METER: "PLAY_HOLD_AND_RESPIN_BLAST_ON_WIN_METER",
  SHOW_TRAIL_TO_COLLECTION: "SHOW_TRAIL_TO_COLLECTION",
  DESTROY_RESPIN: "DESTROY_RESPIN",

  SHOW_BIG_FISH: "SHOW_BIG_FISH",
  KILL_REVEAL_OBJECTS: "KILL_REVEAL_OBJECTS",
  //Jackpot Events
  INITIALIZE_JACKPOT: "INITIALIZE_JACKPOT",
  SHOW_JP_PRESENTATION: "SHOW_JP_PRESENTATION",
  ADD_BANNER_ON_TOP: "ADD_BANNER_ON_TOP",
  TOP_LOGO_SHOW_ON_BIG_WIN: "TOP_LOGO_SHOW_ON_BIG_WIN",
  UPDATE_SPIN_REMAINING_COUNT: "UPDATE_SPIN_REMAINING_COUNT",
  RESET_COUNTER_TO_MAX: "RESET_COUNTER_TO_MAX",
  STOP_JP_BUBBLES: "STOP_JP_BUBBLES",
  SHOW_JACKPOT_BANNER: "SHOW_JACKPOT_BANNER",


  //Collection Events
  CHECK_FOR_COLLECTION_VIEW: "CHECK_FOR_COLLECTION_VIEW",
  INITIALIZE_COLLECTION_SCREEN: "INITIALIZE_COLLECTION_SCREEN",
  SHOW_COLLECTION_SCREEN: "SHOW_COLLECTION_SCREEN",
  CHECK_FOR_PROGRESS: "CHECK_FOR_PROGRESS",
  REVEAL_COLLECTION_AFTER_HNR: "REVEAL_COLLECTION_AFTER_HNR",
  UPDATE_COLLECTION_PAYOUT: "UPDATE_COLLECTION_PAYOUT",
  SHOW_BUBBLE_GLOW: "SHOW_BUBBLE_GLOW",
  SHOW_BANNER_WIN: "SHOW_BANNER_WIN",
  SHOW_COLLECTION_BANNER: "SHOW_COLLECTION_BANNER",
  SHOW_COLLECTION_WINS: "SHOW_COLLECTION_WINS",
  HIDE_COLLECTION_SCREEN: "HIDE_COLLECTION_SCREEN",
  RESET_PROGRESS_AFTER_WIN: "RESET_PROGRESS_AFTER_WIN",
  ADD_COLLECTION_ON_TOP: "ADD_COLLECTION_ON_TOP",
  ADD_COLLECTION_BANNER_ON_TOP: "ADD_COLLECTION_BANNER_ON_TOP",
  // top logo
  HIDE_TOP_LOGO_ON_BANNER_FG: "HIDE_TOP_LOGO_ON_BANNER_FG",
  SHOW_TOP_LOGO_ON_BANNER_FG: "SHOW_TOP_LOGO_ON_BANNER_FG",
  HIDE_TOP_LOGO_ON_BANNER: "HIDE_TOP_LOGO_ON_BANNER",
  SHOW_TOP_LOGO_ON_BANNER: "SHOW_TOP_LOGO_ON_BANNER",
  FADE_WIN_SOUND: "FADE_WIN_SOUND",
};
